import {  Menu,
          NavBar                  } from "components/Menu/menu";
import {  LoaderCover             } from "components/Covers/loadingCover";
import {  InfoMessageModal        } from "components/Covers/infoMessageModal";
import {  ActionConfirmationModal } from "components/Covers/confirmAction";
import {  InfoToast               } from "components/Covers/toastMessage";
import {  HelpModal               } from "components/Covers/helpCover";
import {  SideContent             } from "components/SideContent/sideContent";
import {  useState, 
          useRef, 
          useEffect               } from 'react';
import {  Modal                   } from "components/Covers/genericModal";

export const Layout = ({ children }) => {
    const [size,     setSize]    = useState(0);
    const [scroll,   setScroll]  = useState('hidden');
    const intervalRef            = useRef(null);

    useEffect(() => {
        if (intervalRef.current) return;
        if (size < 100) {
          intervalRef.current = setInterval(() => {
            setSize(prev => {
              if (prev >= 100) {
                setScroll('scroll');
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                return 100;
              }
              return prev + 1;
            });
          }, 15);
        }
    },[]);

    return (
      <>
        <HelpModal/>
        <LoaderCover/>
        <InfoMessageModal/>
        <ActionConfirmationModal/>
        <InfoToast/>
        <Modal/>
        <SideContent/>
        <NavBar>
        	<Menu/>
        </NavBar>
        <div style={{overflow: 'hidden'}}>
			<div style={{height:'100vh', display: 'flex', flexDirection: 'column'}}>
				<div id="MainLayoutContainer" style={{overflowY: scroll}}>
                    <div style={{paddingTop: '60px'}} />
					{ children }
				</div>
			</div>
        </div>
      </>
    );
};
  